import { useState, useEffect } from "react";
import Tour from "reactour";
import "../../assets/scss/bottons.scss";
import ResourceCenter from "@assets/images/ResourceCenter.svg";
import { getTitleCase } from "@utils/utils";
import { useSelector } from "react-redux";
import { LOB_ENUM } from "@routes/intel/ProductOnboarding/utils";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";
import { useLocation } from "react-router-dom";

const onboardingSteps = [{ selector: "#saved-search-button", disableInteraction: true, header: "", description: "", float: "", position: "left", content: "" }];

const getIntelHubHeader = (usersPersona) => {
  switch (usersPersona) {
    case LOB_ENUM.BUSINESS_DEVELOPMENT:
      return (
        <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4">
          <p className="tw-font-semibold tw-text-sm">🚀 Your Personalised Trade Intelligence Dashboard</p>
          <p className="tw-text-sm tw-pt-2">
            Discover high-potential leads tailored to your <strong>bookmarked companies, target markets, and onboarding preferences.</strong>
          </p>
        </p>
      );
    case LOB_ENUM.EXPORT:
    case LOB_ENUM.IMPORT:
    case LOB_ENUM.EXPORT_AND_IMPORT:
      return (
        <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4">
          <p className="tw-font-semibold tw-text-sm">🚀 Your Personalised Trade Intelligence Dashboard</p>
          <p className="tw-text-sm tw-pt-2">
            Explore curated companies tailored to your <strong>bookmarked accounts, target countries, and onboarding preferences</strong>
          </p>
        </p>
      );
    default:
      return <></>;
  }
};

const getIntelHubDescription = (usersPersona) => {
  switch (usersPersona) {
    case LOB_ENUM.BUSINESS_DEVELOPMENT:
      return (
        <>
          <div>
            <p className="tw-text-sm !tw-py-4 !tw-px-4 tw-font-medium">
              <strong>What you can do in AI Prospecting:</strong>
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4 tw-text-sm tw-font-normal">
            <ul className="list-disc tw-space-y-1 tw-px-4 tw-list-outside">
              <li>
                <strong>Track activity</strong> across your bookmarked companies and priority accounts.
              </li>
              <li>
                <strong>Discover new prospects</strong> through AI-recommended companies aligned with your focus markets.
              </li>
              <li>
                <strong>Identify trade opportunities</strong> by monitoring shipment trends, sourcing shifts, and emerging trade corridors.
              </li>
              <li>
                <strong>Refine your recommendations</strong> by updating your onboarding preferences anytime.
              </li>
            </ul>
          </div>
        </>
      );
    case LOB_ENUM.IMPORT:
    case LOB_ENUM.EXPORT:
    case LOB_ENUM.EXPORT_AND_IMPORT:
      return (
        <>
          <div>
            <p className="tw-text-sm !tw-py-4 !tw-px-4 tw-font-medium">
              <strong>What you can do in AI Prospecting:</strong>
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4 tw-text-sm tw-font-normal">
            <ul className="list-disc tw-space-y-1 tw-px-4 tw-list-outside">
              <li>
                Track real-time activity across your <strong>bookmarked buyers, suppliers, and competitors</strong>
              </li>
              <li>
                Discover <strong>AI-recommended companies</strong> aligned with your focus markets and trade behavior
              </li>
              <li>
                Monitor <strong>shipment trends, sourcing shifts, and emerging trade corridors</strong>
              </li>
              <li>
                Analyze <strong>product-level benchmarks and trade volumes by HS Code</strong>
              </li>
              <li>
                Refine your insights anytime by <strong>updating your onboarding preferences</strong>
              </li>
            </ul>
          </div>
        </>
      );
    default:
      return <></>;
  }
};

export default function NudgePopup({ nudgePopupStateObj, handleNudgePopup, currentNudgePopupKey }) {
  const { pathname } = useLocation();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [steps, setSteps] = useState(onboardingSteps);
  const userData = useSelector((state) => state.userDetails.userData);
  const usersPersona = userData?.line_of_business || "";
  const falseValue = false;
  // The workspace nudge ships as per-module keys (workspace_product_search / workspace_company_search /
  // workspace_ui_ue) that all share the same content, so match the whole family here.
  const isWorkspaceNudge = typeof currentNudgePopupKey === "string" && currentNudgePopupKey.startsWith("workspace");

  const triggerNudgeEvent = (actionType) => {
    const currentNudge = nudgePopupStateObj?.[currentNudgePopupKey];
    if (!currentNudge) return;
    const eventValue = actionType === "apply" ? currentNudge.applyEvent : currentNudge.closeEvent;
    if (!eventValue) return;
    trademoTrackingEvents(eventValue, generateTrackingObject("intel-hub", pathname, getUserActivePlan()));
  };

  useEffect(() => {
    setIsTourOpen(false);
    setTimeout(() => {
      setIsTourOpen(true);
    }, 1000);
  }, []);

  useEffect(() => {
    if (isTourOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isTourOpen]);
  useEffect(() => {
    maoOnboardingSteps();
  }, []);
  const maoOnboardingSteps = () => {
    let tempArr = [];
    if (nudgePopupStateObj && currentNudgePopupKey && nudgePopupStateObj[currentNudgePopupKey]) {
      let tempObj = {};
      if (nudgePopupStateObj[currentNudgePopupKey].htmlId) tempObj.selector = `#${nudgePopupStateObj[currentNudgePopupKey].htmlId}`;
      if (nudgePopupStateObj[currentNudgePopupKey].disableInteraction) tempObj.disableInteraction = nudgePopupStateObj[currentNudgePopupKey].disableInteraction;
      if (nudgePopupStateObj[currentNudgePopupKey].position) tempObj.position = nudgePopupStateObj[currentNudgePopupKey].position;
      tempObj["content"] = () => (
        <div>
          <div className="postion-relative">
            {nudgePopupStateObj[currentNudgePopupKey].crossClose ? (
              <div className="d-flex justify-content-between align-items-center mb-2">
                <img className="nudge_switch" src="https://res.cloudinary.com/drzta9shk/image/upload/v1686743326/intel/icons/toogle-switch-reversed_jiqzco.gif" />
                <div className="position-absolute close_nudge">
                  <img
                    onClick={() => {
                      triggerNudgeEvent("close");
                      handleNudgePopup("close");
                    }}
                    src="https://res.cloudinary.com/drzta9shk/image/upload/v1686743261/intel/icons/cancel_miogvu.svg"
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            {currentNudgePopupKey === "new_credit_system" ? (
              <div className="tw-flex tw-flex-col tw-px-4">
                <div className="tw-flex tw-justify-start tw-items-center">
                  <div className="tw-h-fit tw-w-fit alerts-border-blink tw-rounded-full tw-py-1 tw-px-3 tw-text-warning-700 tw-font-semibold tw-flex tw-items-center tw-justify-center tw-shadow-inner-orange-border tw-text-sm">Important Update</div>
                </div>
                {<h4>{`Introducing New Credit Pool Structure & Credit Allocation`}</h4>}
              </div>
            ) : (
              <></>
            )}
            {currentNudgePopupKey === "hs_classifier" ? <div className="tw-flex tw-flex-col tw-px-4">{<h4>{`Introducing AI-Powered HS Classification`}</h4>}</div> : <></>}
            {currentNudgePopupKey === "compare_tariff" ? <div className="tw-flex tw-flex-col tw-px-4">{<h4>{`Introducing Tariffs`}</h4>}</div> : <></>}
            {currentNudgePopupKey === "company_search" ? <div className="tw-flex tw-flex-col">{<h4 className="!tw-text-lg !tw-pt-0">{`Introducing Search Companies`}</h4>}</div> : <></>}
            {currentNudgePopupKey === "intel_hub" ? <div className="tw-flex tw-flex-col">{<h4 className="!tw-text-lg !tw-pt-0">{`Introducing AI Prospecting`}</h4>}</div> : <></>}
            {currentNudgePopupKey === "hermes_chat" ? <div className="tw-flex tw-flex-col">{<h4 className="!tw-text-lg !tw-pt-0">{`Meet your new AI-powered trade assistant.`}</h4>}</div> : <></>}
            {isWorkspaceNudge ? <div className="tw-flex tw-flex-col">{<h4 className="!tw-text-sm tw-font-semibold !tw-pt-0 tw-border-b tw-border-gray-200 tw-pb-2">Introducing Workspace</h4>}</div> : <></>}
            {!nudgePopupStateObj[currentNudgePopupKey].crossClose ? (
              currentNudgePopupKey === "new_credit_system" || currentNudgePopupKey === "due_diligence_reports" || currentNudgePopupKey === "company_search" || currentNudgePopupKey === "intel_hub" || currentNudgePopupKey === "hermes_chat" || currentNudgePopupKey === "product_search" || isWorkspaceNudge ? (
                <div className="tw-flex tw-justify-center">
                  <img src={`${nudgePopupStateObj[currentNudgePopupKey].backgroundImgUrl || "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg"}`} className={isWorkspaceNudge ? "tw-max-w-[60%]" : "tw-max-w-full"} />
                </div>
              ) : (
                <div
                  className="image-container tw-flex tw-justify-center tw-items-center tw-relative tw-bg-cover tw-bg-center tw-h-[120px]"
                  style={{
                    backgroundImage: `url(${nudgePopupStateObj[currentNudgePopupKey].backgroundImgUrl || "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg"})`,
                  }}>
                  {nudgePopupStateObj[currentNudgePopupKey].iconUrl ? <img className="tw-w-full tw-absolute tw-h-[100px] tw-z-10" src={nudgePopupStateObj[currentNudgePopupKey].iconUrl || "https://res.cloudinary.com/drzta9shk/image/upload/v1683696233/intel/icons/nudge_savesearch_icon_krmu1k.svg"} /> : <img className="tw-w-full tw-absolute tw-h-[100px] tw-z-10" src={ResourceCenter} />}
                </div>
              )
            ) : (
              <></>
            )}

            {nudgePopupStateObj[currentNudgePopupKey].header && !nudgePopupStateObj[currentNudgePopupKey]?.headerOnTop ? <h4>{nudgePopupStateObj[currentNudgePopupKey].header}</h4> : <></>}
            {nudgePopupStateObj[currentNudgePopupKey].subText1 ? <h4>{nudgePopupStateObj[currentNudgePopupKey].subText1}</h4> : <></>}
            {currentNudgePopupKey === "due_diligence_reports" ? (
              <p className="!tw-py-4 !tw-text-sm !tw-font-medium !tw-px-4">
                You can now use <strong> Value Add Credits</strong> to access <strong>Due Diligence Reports</strong>
              </p>
            ) : currentNudgePopupKey !== "new_credit_system" && nudgePopupStateObj[currentNudgePopupKey].description ? (
              <p className="pb-2">
                <i>{nudgePopupStateObj[currentNudgePopupKey].description}</i>
              </p>
            ) : currentNudgePopupKey === "new_credit_system" ? (
              <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4"> 🎉 Great news! Email and phone credits are now merged into one — use as per your requirement</p>
            ) : currentNudgePopupKey === "hs_classifier" ? (
              <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4"> 🚀 Great news! You can now classify your products with our AI-enabled HS Classification tool — making your search more accurate than ever. </p>
            ) : currentNudgePopupKey === "compare_tariff" ? (
              <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4"> 🚀 Smarter trade decisions just got easier! Our new Tariffs feature lets you instantly view and compare the latest tariffs across countries, so you can identify cost savings and plan with confidence. </p>
            ) : currentNudgePopupKey === "company_search" ? (
              <p className="!tw-py-4 !tw-text-base !tw-font-normal !tw-px-4">
                🚀 Great news! The new <strong>Search Companies</strong> is here! Discover a simpler, faster way to find companies — all in one place.
              </p>
            ) : currentNudgePopupKey === "intel_hub" ? (
              getIntelHubHeader(usersPersona)
            ) : currentNudgePopupKey === "hermes_chat" ? (
              <p className="!tw-py-4 !tw-text-sm !tw-font-normal !tw-px-4">Finding the right global trade connections just got as simple as sending a text. Instead of navigating complex filters and endless menus, you can now search our entire ecosystem using natural, everyday language. Whether you need to track a particular company or scout the market for new opportunities, your assistant is ready to do the heavy lifting.</p>
            ) : currentNudgePopupKey === "product_search" ? (
              <div className="tw-text-sm tw-mt-4">
                <div className="tw-font-semibold tw-pb-2">Introducing Find Buyers & Suppliers!</div>
                Search by product or HS code to analyze market trends and tariff data. Gain the insights you need to optimize sourcing and connect with the right buyers.
              </div>
            ) : isWorkspaceNudge ? (
              <p className="!tw-py-4 !tw-text-sm !tw-font-normal !tw-px-4">🚀 Everything you need to uncover trade opportunities and make smarter decisions, in one workspace.</p>
            ) : (
              <></>
            )}
            {(currentNudgePopupKey === "new_credit_system" || currentNudgePopupKey === "hs_classifier" || currentNudgePopupKey === "compare_tariff") && <p className="tw-border-t tw-bg-gray-200"></p>}
            {currentNudgePopupKey === "due_diligence_reports" ? (
              <>
                <p className="!tw-text-sm !tw-font-normal !tw-py-4 !tw-px-4">Access due diligence reports to learn about the company’s:</p>
                <div className="tw-flex tw-text-sm tw-font-normal tw-flex-col tw-gap-2 tw-px-4">
                  <ul className="list-disc tw-space-y-2 tw-px-4">
                    <li>Shareholder and Key Personnel Information</li>
                    <li>Financial and Credit Analysis</li>
                    <li>Legal and Compliance Checks</li>
                    <li>Certifications and Ratings</li>
                    <li>Ownership and Management Details</li>
                  </ul>
                </div>
              </>
            ) : currentNudgePopupKey !== "new_credit_system" && Array.isArray(nudgePopupStateObj[currentNudgePopupKey]?.subheaders) && nudgePopupStateObj[currentNudgePopupKey]?.subheaders?.length > 0 ? (
              nudgePopupStateObj[currentNudgePopupKey]?.subheaders?.map((item) => (
                <div key={item} className="tw-mb-3 !tw-block">
                  <h6>{item.subHeader}</h6>
                  {item?.pointers && (
                    <ul className="tw-ml-4">
                      {item.pointers.map((pointer) => (
                        <li key={pointer}>hello{pointer}</li>
                      ))}
                    </ul>
                  )}

                  <p>{getTitleCase(item.subText)}</p>
                </div>
              ))
            ) : currentNudgePopupKey === "new_credit_system" ? (
              <>
                <div>
                  <p className="!tw-text-base !tw-font-normal !tw-py-4 !tw-px-4">Now, your credits are organised into:</p>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
                  <ul className="list-disc tw-space-y-2 tw-px-4">
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Download Credits</h4>
                      for downloading shipment data.
                    </li>
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Value Add Credits</h4>
                      for accessing contacts, emails and due diligence reports.
                    </li>
                  </ul>
                </div>
              </>
            ) : currentNudgePopupKey === "hs_classifier" ? (
              <>
                <div>
                  <p className="!tw-text-base !tw-font-normal !tw-py-4 !tw-px-4">With this new feature, you can:</p>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
                  <ul className="list-disc tw-space-y-2 tw-px-4">
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Classify Products</h4>
                      instantly with AI-powered HS codes.
                    </li>
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Boost Search Accuracy</h4>
                      with precise HS code-based results.
                    </li>
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Save & Reuse</h4>
                      classified codes for future searches and analysis.
                    </li>
                  </ul>
                </div>
              </>
            ) : currentNudgePopupKey === "compare_tariff" ? (
              <>
                <div>
                  <p className="!tw-text-base !tw-font-normal !tw-py-4 !tw-px-4">With this new feature, you can:</p>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
                  <ul className="list-disc tw-space-y-2 tw-px-4">
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Compare Markets -</h4>
                      spot tariff differences
                    </li>
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Stay Updated -</h4>
                      access the most current tariff data
                    </li>
                    <li>
                      <h4 className="tw-inline tw-mr-[5px]">Trade Smarter -</h4>
                      choose the most cost-effective markets
                    </li>
                  </ul>
                </div>
              </>
            ) : currentNudgePopupKey === "company_search" ? (
              <>
                <div>
                  <p className="!tw-text-base !tw-font-normal !tw-py-4 !tw-px-4">With this new feature, you can:</p>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
                  <ul className="list-disc tw-space-y-2 tw-px-4">
                    <li>
                      {/* <h4 className="tw-inline tw-mr-[5px]">Compare Markets -</h4>
                  spot tariff differences */}
                      <strong> Search by company name or keyword </strong>, or instantly <strong>explore buyers and suppliers by product or HS code.</strong>
                    </li>
                    <li>
                      {/* <h4 className="tw-inline tw-mr-[5px]">Stay Updated -</h4>
                  access the most current tariff data */}
                      Enjoy a <strong> Streamlined Experience </strong> with guided inputs, smart filters, and clear company insights that make it easier than ever to pinpoint the right businesses.
                    </li>
                    <li>
                      {/* <h4 className="tw-inline tw-mr-[5px]">Trade Smarter -</h4>
                  choose the most cost-effective markets */}
                      Try switching between the <strong> Company</strong> and <strong>Product / HS Code </strong> tabs to get started.
                    </li>
                  </ul>
                </div>
              </>
            ) : currentNudgePopupKey === "intel_hub" ? (
              getIntelHubDescription(usersPersona)
            ) : isWorkspaceNudge ? (
              <div className="tw-px-4 tw-pt-3 tw-border-t tw-border-gray-200">
                <ul className="tw-list-disc tw-pl-4 tw-space-y-1 tw-text-sm tw-text-gray-900">
                  <li>
                    <strong>Score and Enrich Opportunities:</strong> Instantly add crucial details like verified contact data, pricing, revenue, and employee counts to your workspace.
                  </li>
                  <li>
                    <strong>Download or Track with Ease:</strong> Shortlist your top prospects and export their enriched data via download, or bookmark them to monitor updates in real time.
                  </li>
                </ul>
              </div>
            ) : (
              <></>
            )}
            {nudgePopupStateObj[currentNudgePopupKey]?.highlightedText && <h4 className="tw-text-xs tw-font-medium tw-text-primary-purple-400">{nudgePopupStateObj[currentNudgePopupKey]?.highlightedText}</h4>}
          </div>
          {!nudgePopupStateObj[currentNudgePopupKey].crossClose ? (
            <div className={`${currentNudgePopupKey === "new_credit_system" || currentNudgePopupKey === "due_diligence_reports" || currentNudgePopupKey === "hs_classifier" || currentNudgePopupKey === "compare_tariff" || currentNudgePopupKey === "company_search" || currentNudgePopupKey === "intel_hub" || currentNudgePopupKey === "hermes_chat" || currentNudgePopupKey === "product_search" || isWorkspaceNudge ? "button-container !tw-justify-end !tw-gap-4" : "button-container"}`}>
              {nudgePopupStateObj[currentNudgePopupKey].cancelButtonText ? (
                <button
                  onClick={() => {
                    triggerNudgeEvent("close");
                    handleNudgePopup("close");
                  }}
                  className="btn btn-sm btn-outline-secondary trademo-outline-btn">
                  {nudgePopupStateObj[currentNudgePopupKey].cancelButtonText}
                </button>
              ) : (
                <></>
              )}
              {nudgePopupStateObj[currentNudgePopupKey].applyButtonText ? (
                <button
                  onClick={() => {
                    triggerNudgeEvent("apply");
                    handleNudgePopup("apply");
                  }}
                  className="btn btn-sm btn-primary trademo-new-btn !tw-font-semiboldF ">
                  {nudgePopupStateObj[currentNudgePopupKey].applyButtonText}
                </button>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      );
      tempArr.push(tempObj);
      setSteps([...tempArr]);
    } else if (steps && Array.isArray(steps) && steps.length) {
      steps.forEach((item) => {
        let tempObj = {};
        if (item.selector) tempObj.selector = item.selector;
        if (item.disableInteraction) tempObj.disableInteraction = item.disableInteraction;
        if (item.position) tempObj.position = item.position;
        tempObj["content"] = () => (
          <div>
            <div>
              {item.header ? <h4>{item.header}</h4> : <></>}
              {item.description ? (
                <p>
                  <i>{item.description}</i>
                </p>
              ) : (
                <></>
              )}
            </div>
            <div style={{ float: "left" }}></div>
          </div>
        );
        tempArr.push(tempObj);
      });
      setSteps([...tempArr]);
    }
  };

  return <div>{isTourOpen ? <Tour className="nudge-popup" steps={steps} isOpen={isTourOpen} disableInteraction={true} closeWithMask={false} showCloseButton={false} scrollDuration={0} rounded={10} badgeContent={(curr, tot) => `${curr} of ${tot}`} disableDotsNavigation={falseValue} number={3} showNavigation={falseValue} /> : <></>}</div>;
}
